import { buildCreateSlice, asyncThunkCreator } from '@reduxjs/toolkit';

import { initialState } from './initial';
import { reducers } from './reducers';

export const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

export const categoriesSlice = createAppSlice({
  name: 'categories',
  initialState,
  reducers,
});

export const { fetchCategories, fetchAllProjectCategoriesForChannel, setAllProjectCategoriesInStoreOnly } =
  categoriesSlice.actions;

export default categoriesSlice.reducer;
